import { useTranslation } from 'react-i18next';
import { type FC } from 'react';
import ClinicFilterSelectBox from 'components/molecules/include-exclude-clinic-select-box';

import s from './styles.module.scss';

import type { TTablePrefix } from 'infrastructure/interfaces';

interface AccountSelectBoxProps {
  tablePrefix: TTablePrefix;
  updateFilter: <T>(newFilter: Partial<T>) => void;
  clinicGuid?: string[];
  excludeClinicGuid?: string[];
  isAllExcluded?: boolean;
}

export const AccountsSelect: FC<AccountSelectBoxProps> = ({
  tablePrefix,
  clinicGuid,
  excludeClinicGuid,
  isAllExcluded,
  updateFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s['select-wrapper-accounts']}>
      <label className={s['select-label']}>
        <span>{t('labels.clinicsListFilter')}:</span>
        <ClinicFilterSelectBox
          useAdminApi
          withoutLabel
          showOnInteractiveTimeDashboard={false}
          excluded={excludeClinicGuid}
          included={clinicGuid}
          allExcluded={isAllExcluded}
          onChange={({ included = [], excluded = [], allExcluded = false }) => {
            updateFilter({
              [`${tablePrefix}clinicGuid`]: included,
              [`${tablePrefix}excludeClinicGuid`]: excluded,
              [`${tablePrefix}allExcluded`]: allExcluded,
              [`${tablePrefix}page`]: undefined,
            });
          }}
        />
      </label>
    </div>
  );
};
